// extracted by mini-css-extract-plugin
export default {"bgBarTitle":"style-module--bgBarTitle---Vd6P","wrapperForm":"style-module--wrapperForm--F8HEZ"};